import api from "../api/api";
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const gradeService = {



 

  obterTodos: async (params) => {
    try {
      const url = `${BASE_URL}/grade-lista`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter grade:", error);
      throw new Error("Erro ao obter grade.");
    }
  },

  
  
};
